import { defineRouting } from 'next-intl/routing';

import { routingDefaultLocale as defaultLocale, routingDomains as domains, routingLocales as locales } from './locales';

export const routing = defineRouting({
  defaultLocale,
  domains,
  localePrefix: 'always',
  locales,
});
